import { Fonts } from '@qirapagos/lib/theme'
import { gray, white, violet, violetLight, violetDisabled } from 'theme/colors'
import styled from 'styled-components'
import { DEVICES } from 'theme/devicesSizes'

export const Container = styled.div<{ width?: string | number; height?: string | number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  padding: 24px 24px 16px 24px;
  background-color: ${white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  position: relative;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  align-items: center;
`

export const RightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Title = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: ${gray};
  @media ${DEVICES.mobile} {
    font-size: 10px;
  }
`

export const Subtitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${gray};
`

export const AmountContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-self: center;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
  @media ${DEVICES.mobile} {
    height: 80px;
  }
`

export const EyeButton = styled.button`
  display: flex;
  margin-left: 21px;
`

export const BalanceWithNoDecimals = styled.div`
  font-size: 28.61px;
  font-family: ${Fonts.POPPINS_MED};
  font-weight: 600;
  @media ${DEVICES.mobile} {
    font-size: 24px;
  }
`

export const BalanceDecimals = styled.div`
  align-self: flex-start;
  align-items: flex-end;
  margin-top: 7px;
  font-size: 12px;
  font-family: ${Fonts.POPPINS_MED};
  font-weight: 600;
  @media ${DEVICES.mobile} {
    margin-top: 26px;
  }
`

export const CustomButton = styled.button`
  display: flex;
  color: ${violet};
  background-color: transparent;
  font-size: 10px;
  font-weight: 500;
  text-decoration: underline;
`

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  margin-bottom: 4px;
`

export const InvestmentButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  width: 111px;
  height: 34px;
  background-color: ${violetLight};
  color: ${({ $disabled }) => ($disabled ? violetDisabled : violet)};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: opacity 0.2s, background-color 0.2s, color 0.2s;

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? 1 : 0.9)};
  }
`
